<template>
    <!-- <p v-if="$route.path === '/addresses'">收货地址头部</p> -->
    <header v-if="$route.path=== '/addresses'" class="addresses-header layout-header">
            <van-icon name="arrow-left" @click="$router.go(-1)"></van-icon>
            <b>お届け先管理</b>
    </header>
</template>
<script>
export default {
    name: "AddressesHeader"
}
</script>
<style scoped>
/* 收货地址组件头部 */
.addresses-header {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.addresses-header .van-icon {
    position: absolute;
    left: 15px;
    /* color: var(--red-light); */
    font-size: 20px;
}

</style>